module.exports = __webpack_public_path__ + "img/ombg1.2dcfa523.png";